// import React, { useState, useEffect } from "react";
// import Navbar from "layouts/ecommerce/posnavbar/Navbar";
// import { Box, Grid, Modal, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import SessionPageLeft from "../../../sessionPageV2/SessionPageLeft";
// import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
// import { useNavigate } from "react-router-dom";
// import { ArrowLongRightIcon } from "@heroicons/react/20/solid";
// import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
// import usePrint from "../../../hooks/usePrint";
// import {
//   closeDay,
//   getEndDayReportData,
//   activeSessionDay,
//   getAllActiveSessions,
// } from "../../../../../../config/Services";
// import { useSnackbar } from "../../../hooks/SnackbarProvider";
// import Swal from "sweetalert2";

// const DayClosing = () => {
//   const navigate = useNavigate();
//   const { startPrint, isPrinting } = usePrint();
//   const showSnackbar = useSnackbar();

//   const [loading, setLoading] = useState(false);
//   const [endDayLoading, setEndDayLoading] = useState(false);
//   const [hasActiveSessions, setHasActiveSessions] = useState(false);
//   const [checkingSession, setCheckingSession] = useState(true);
//   const [endDayModalOpen, setEndDayModalOpen] = useState(false);

//   const daySessionId = localStorage.getItem("daySessionId");
//   const orgId = localStorage.getItem("orgId");
//   const locationId = localStorage.getItem("locId");
//   let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));

//   const newSwal = Swal.mixin({
//     customClass: {
//       confirmButton: "button button-success",
//       cancelButton: "button button-error",
//       container: "close-session-swal-container",
//     },
//     buttonsStyling: false,
//   });

//   useEffect(() => {
//     checkActiveSessions();
//   }, []);

//   const checkActiveSessions = async () => {
//     try {
//       setCheckingSession(true);
//       const response = await getAllActiveSessions(locationId);
//       if (response && response?.data?.statusCode === 200 && response?.data?.es === 0) {
//         setHasActiveSessions(true);
//         showSnackbar(
//           "There are still active sessions. Please close all sessions before ending the day.",
//           "warning"
//         );
//       } else {
//         setHasActiveSessions(false);
//       }
//     } catch (error) {
//     } finally {
//       setCheckingSession(false);
//     }
//   };

//   const clearLocalStorageData = () => {
//     localStorage.clear();
//   };

//   const handleCloseDay = () => {
//     const payload = {
//       sessionId: daySessionId,
//       updatedBy: retailUserLocalStorageData?.uidx,
//     };

//     closeDay(payload)
//       .then((closeRes) => {
//         showSnackbar("Day closed successfully", "success");
//         clearLocalStorageData();

//         newSwal.fire({
//           title: "Day Closed!",
//           text: "The day has been closed successfully.",
//           icon: "success",
//           timer: 1500,
//           showConfirmButton: false,
//         });

//         setTimeout(() => {
//           navigate("/");
//         }, 1500);
//       })
//       .catch((err) => {
//         showSnackbar("There was an error closing the day", "error");
//         setEndDayLoading(false);
//       });
//   };

//   // Opens the modal when End Day button is clicked
//   const handleEndDayClick = () => {
//     // if (hasActiveSessions) {
//     //   showSnackbar("Cannot end day. There are still active sessions.", "error");
//     //   return;
//     // }
//     setEndDayModalOpen(true);
//   };

//   // Close the modal
//   const handleCloseModal = () => {
//     setEndDayModalOpen(false);
//   };

//   // End day without report
//   const handleEndDayWithoutReport = () => {
//     setEndDayModalOpen(false);
//     const isInventoryConfigSet = localStorage.getItem("isInventoryConfigSet");

//     if (isInventoryConfigSet) {
//       // Navigate to stock count page if inventory config is set
//       navigate("/session-page/day/closing/end");
//     } else {
//       // Show confirmation and close day directly if inventory config is not set
//       newSwal
//         .fire({
//           title: "Are you sure you want to end the day?",
//           icon: "warning",
//           showCancelButton: true,
//           confirmButtonText: "Yes, End Day",
//           cancelButtonText: "Cancel",
//           backdrop: "rgba(0,0,0,0.4)",
//         })
//         .then((result) => {
//           if (result.isConfirmed) {
//             setEndDayLoading(true);
//             handleCloseDay();
//           }
//         });
//     }
//   };

//   // End day with report generation
//   const handleEndDayWithReport = () => {
//     setEndDayModalOpen(false);
//     setLoading(true);
//     const isInventoryConfigSet = localStorage.getItem("isInventoryConfigSet");

//     getEndDayReportData(locationId, orgId)
//       .then((response) => {
//         if (response?.data?.data?.es > 0) {
//           showSnackbar("Error while generating report", "error");
//           setLoading(false);
//           return;
//         }
//         const dataToprint = response?.data?.data;
//         setTimeout(() => {
//           startPrint({
//             productData: dataToprint,
//             printType: "end-report",
//             onPrintComplete: () => {
//               setLoading(false);

//               if (isInventoryConfigSet) {
//                 navigate("/session-page/day/closing/end");
//               } else {
//                 newSwal
//                   .fire({
//                     title: "Do you want to close the day?",
//                     icon: "question",
//                     showCancelButton: true,
//                     confirmButtonText: "Yes, Close day",
//                     cancelButtonText: "No",
//                     backdrop: "rgba(0,0,0,0.4)",
//                   })
//                   .then((result) => {
//                     if (result.isConfirmed) {
//                       handleCloseDay();
//                     }
//                   });
//               }
//             },
//             onPrintError: () => {
//               setLoading(false);
//               showSnackbar("Failed to print report", "error");
//             },
//           });
//         }, 100);
//       })
//       .catch((error) => {
//         setLoading(false);
//         showSnackbar("Failed to fetch report data", "error");
//       });
//   };

//   // Modal styles
//   const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 420,
//     bgcolor: "background.paper",
//     borderRadius: "8px",
//     boxShadow: 24,
//     p: 3,
//   };

//   return (
//     <>
//       <main className="newSessionRightContainer">
//         <div className="newSessionListingContainer">
//           <div className="newSessionRightInnerContainer">
//             <p className="startText">What do you want to do next?</p>
//           </div>
//           <div className="newSessionListingButtonContainer">
//             <PosCustomButton
//               title="End Day"
//               width="50%"
//               p={"12px 16px"}
//               radius="4px"
//               variant="red-transparent"
//               loading={endDayLoading || loading}
//               // disabled={hasActiveSessions || checkingSession}
//               onClickFunction={handleEndDayClick}
//             />
//             <PosCustomButton
//               title="Start New Session"
//               width="50%"
//               p={"12px 16px"}
//               radius="4px"
//               variant="blue-d"
//               onClickFunction={() => navigate("/session-page/start-day")}
//             />
//           </div>
//         </div>
//       </main>

//       {/* End Day Options Modal */}
//       <Modal
//         open={endDayModalOpen}
//         onClose={handleCloseModal}
//         aria-labelledby="end-day-modal-title"
//         aria-describedby="end-day-modal-description"
//       >
//         <Box sx={modalStyle}>
//           {/* Modal Header */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 1,
//             }}
//           >
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//               <span role="img" aria-label="sun" style={{ fontSize: "20px" }}>
//                 🌤️
//               </span>
//               <span
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: 600,
//                   color: "#1a1a1a",
//                 }}
//               >
//                 How Do You Want To End The Day?
//               </span>
//             </Box>
//             <IconButton onClick={handleCloseModal} size="small" sx={{ color: "#666" }}>
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           </Box>

//           {/* Modal Subtitle */}
//           <p
//             style={{
//               fontSize: "14px",
//               color: "#666",
//               margin: "0 0 24px 0",
//             }}
//           >
//             Pick one of the options below to wrap up your day!
//           </p>

//           {/* Modal Buttons */}
//           <Box
//             sx={{
//               display: "flex",
//               gap: 2,
//               justifyContent: "center",
//             }}
//           >
//             <PosCustomButton
//               title="End day without report"
//               width="50%"
//               p={"12px 16px"}
//               radius="4px"
//               variant="red-transparent"
//               loading={endDayLoading}
//               onClickFunction={handleEndDayWithoutReport}
//             />
//             <PosCustomButton
//               title="End day with Report"
//               width="50%"
//               p={"12px 16px"}
//               radius="4px"
//               variant="blue-d"
//               loading={loading}
//               onClickFunction={handleEndDayWithReport}
//             />
//           </Box>
//         </Box>
//       </Modal>
//     </>
//   );
// };

// export default DayClosing;

import React, { useState, useEffect, useContext } from "react";
import { Box, Grid, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SessionPageLeft from "../../../sessionPageV2/SessionPageLeft";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { useNavigate } from "react-router-dom";
import {
  PrinterIcon,
  HomeIcon,
  CalendarDaysIcon,
  CheckCircleIcon,
  ArrowRightIcon,
  ArrowPathIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/outline";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import usePrint from "../../../hooks/usePrint";
import {
  closeDay,
  getEndDayReportData,
  activeSessionDay,
  getAllActiveSessions,
  logoutSession,
  getSessionClosingReportsDownload,
} from "../../../../../../config/Services";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import Swal from "sweetalert2";
import SliderTabManager from "../../../all-products/components/sliderModalManger";
import { UserContext } from "../../../../../../App";
import { useDispatch } from "react-redux";
import { setUSBDevice } from "../../../all-products/redux/Actions/printingDeviceActions";

const DayClosing = ({ navigate, closedSessionId }) => {
  const navigateToPath = useNavigate();
  const { startPrint, isPrinting } = usePrint();
  const showSnackbar = useSnackbar();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const { totalAmountDen, setTotalamountDen } = useContext(UserContext);

  const { denoArr, setDenoArr } = useContext(UserContext);

  const [comment, setComment] = useState("");
  const [commentI, setCommentI] = useState("");

  const [loading, setLoading] = useState(false);
  const [endDayLoading, setEndDayLoading] = useState(false);
  const [reportDownloadLoading, setReportDownloadLoading] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [hasActiveSessions, setHasActiveSessions] = useState(false);
  const [checkingSession, setCheckingSession] = useState(true);
  const [endDayModalOpen, setEndDayModalOpen] = useState(false);
  // NEW: track if day closing is done to show success screen
  const [dayClosedSuccess, setDayClosedSuccess] = useState(false);

  const daySessionId = localStorage.getItem("daySessionId");
  const orgId = localStorage.getItem("orgId");
  const locationId = localStorage.getItem("locId");
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));

  const newSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-success",
      cancelButton: "button button-error",
      container: "close-session-swal-container",
    },
    buttonsStyling: false,
  });

  useEffect(() => {
    checkActiveSessions();
  }, []);

  const checkActiveSessions = async () => {
    try {
      setCheckingSession(true);
      const response = await getAllActiveSessions(locationId);
      if (response && response?.data?.statusCode === 200 && response?.data?.es === 0) {
        setHasActiveSessions(true);
      } else {
        setHasActiveSessions(false);
      }
    } catch (error) {
    } finally {
      setCheckingSession(false);
    }
  };

  const clearLocalStorageData = () => {
    localStorage.clear();
  };

  const handleCloseDay = () => {
    const payload = {
      sessionId: daySessionId,
      updatedBy: retailUserLocalStorageData?.uidx,
    };

    closeDay(payload)
      .then((closeRes) => {
        showSnackbar("Day closed successfully", "success");

        clearLocalStorageData();

        // NEW: show success screen instead of swal + navigateToPath
        setDayClosedSuccess(true);
        setEndDayLoading(false);

        /* OLD: swal + navigateToPath
        newSwal.fire({
          title: "Day Closed!",
          text: "The day has been closed successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setTimeout(() => {
          navigateToPath("/");
        }, 1500);
        */
      })
      .catch((err) => {
        showSnackbar("There was an error closing the day", "error");
        setEndDayLoading(false);
      });
  };

  const handleEndDayClick = () => {
    if (hasActiveSessions) {
      showSnackbar("Cannot end day. There are still active sessions.", "error");
      return;
    }
    // setEndDayModalOpen(true);
    navigate("END_OF_DAY_SUMMARY_PAGE");
    // setOpen(true)
  };

  const handleCloseModal = () => {
    // setEndDayModalOpen(false);
    setOpen(false);
  };

  const handleEndDayWithoutReport = () => {
    setEndDayModalOpen(false);
    const isInventoryConfigSet = localStorage.getItem("isInventoryConfigSet");

    if (isInventoryConfigSet) {
      // navigateToPath("/session-page/day/closing/end");
      navigate("END_DAY_CLOSING_PAGE");
    } else {
      newSwal
        .fire({
          title: "Are you sure you want to end the day?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, End Day",
          cancelButtonText: "Cancel",
          backdrop: "rgba(0,0,0,0.4)",
        })
        .then((result) => {
          if (result.isConfirmed) {
            setEndDayLoading(true);
            handleCloseDay();
          }
        });
    }
  };

  const handleEndDayWithReport = () => {
    setEndDayModalOpen(false);
    setLoading(true);
    const isInventoryConfigSet = localStorage.getItem("isInventoryConfigSet");

    const printerConfig = localStorage.getItem("printerConfig");
    const parsedConfig = printerConfig ? JSON.parse(printerConfig) : null;
    const isUSBPrinter =
      !parsedConfig || (parsedConfig.label !== "Bluetooth" && parsedConfig.label !== "Serial port");

    // For USB printers, requestDevice MUST be called synchronously within the
    // user gesture.  We request the device now, save it to Redux so that
    // printUSB finds it via usbDevice (useSelector), and save to localStorage
    // for persistence across page reloads.
    let usbReady = Promise.resolve();
    if (isUSBPrinter && !localStorage.getItem("savedUSBPrinterDevice")) {
      usbReady = navigator.usb.requestDevice({ filters: [{ classCode: 7 }] }).then((device) => {
        dispatch(setUSBDevice(device));
        localStorage.setItem(
          "savedUSBPrinterDevice",
          JSON.stringify({ vendorId: device.vendorId, productId: device.productId })
        );
      });
    }

    getEndDayReportData(locationId, orgId)
      .then(async (response) => {
        if (response?.data?.data?.es > 0) {
          showSnackbar("Error while generating report", "error");
          setLoading(false);
          return;
        }

        const deviceOk = await usbReady
          .then(() => true)
          .catch(() => {
            showSnackbar("Printer selection cancelled", "error");
            setLoading(false);
            return false;
          });
        if (!deviceOk) return;

        const dataToprint = response?.data?.data;
        setTimeout(() => {
          startPrint({
            productData: { data: dataToprint },
            printType: "end-report",
            onPrintComplete: () => {
              setLoading(false);

              if (isInventoryConfigSet) {
                navigate("END_DAY_CLOSING_PAGE");
              } else {
                newSwal
                  .fire({
                    title: "Do you want to close the day?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Close day",
                    cancelButtonText: "No",
                    backdrop: "rgba(0,0,0,0.4)",
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      handleCloseDay();
                    }
                  });
              }
            },
            onPrintError: () => {
              setLoading(false);
              showSnackbar("Failed to print report", "error");
            },
          });
        }, 100);
      })
      .catch((error) => {
        setLoading(false);
        showSnackbar("Failed to fetch report data", "error");
      });
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 420,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 3,
  };

  const handleDownloadSessionReport = async () => {
    if (!closedSessionId) {
      showSnackbar("Session ID not found", "error");
      return;
    }

    const maxAttempts = 4;
    const retryDelayMs = 3000;
    let lastErrorMessage = "";

    setReportDownloadLoading(true);

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        const res = await getSessionClosingReportsDownload(closedSessionId);
        if (res?.data?.status === "SUCCESS" && res?.data?.data?.url) {
          window.open(res.data.data.url, "_blank");
          setReportDownloadLoading(false);
          return;
        }
      } catch (error) {
        lastErrorMessage = error?.response?.data?.message?.toLowerCase() || "";
      }

      if (attempt < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
      }
    }

    setReportDownloadLoading(false);
    if (lastErrorMessage.includes("no report found")) {
      showSnackbar("No report available for the session", "error");
    } else {
      showSnackbar("Failed to download session report", "error");
    }
  };

  const handleLogoutFn = async () => {
    if (logoutLoading) return;
    setLogoutLoading(true);
    try {
      await logoutSession();
    } catch (error) {
      showSnackbar("error while logging out", "error");
    } finally {
      Object.keys(localStorage)?.forEach((key) => {
        if (key !== "printerConfig") localStorage.removeItem(key);
      });
      navigateToPath("/");
      setLogoutLoading(false);
    }
  };

  return (
    <>
      <main className="newSessionRightContainer">
        <div className="day-close-success-wrapper">
          {/* Check icon */}
          <div className="day-close-success-icon-ring">
            <CheckCircleIcon className="day-close-success-icon" />
          </div>

          <h2 className="day-close-success-title">Session Closed Successfully</h2>
          <p className="day-close-success-subtitle">
            All transactions have been reconciled and the cash drawer status has been updated.
          </p>

          {/* Start New Session button */}
          <div
            className="day-close-success-actions"
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <button
              className="dcs-btn dcs-btn-outline"
              onClick={() => navigateToPath("/session-page/start-day")}
            >
              <ArrowPathIcon className="dcs-btn-icon" aria-hidden="true" />
              Start New Session
            </button>
            <button
              className="dcs-btn dcs-btn-outline"
              onClick={handleDownloadSessionReport}
              disabled={reportDownloadLoading}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "max-content",
                alignSelf: "center",
                padding: "8px 24px",
                height: "42px",
                position: "relative",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  visibility: reportDownloadLoading ? "hidden" : "visible",
                }}
              >
                <ArrowDownTrayIcon className="dcs-btn-icon" aria-hidden="true" />
                Download session report
              </span>
              {reportDownloadLoading && (
                <span
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span className="dcs-btn-spinner-light" />
                </span>
              )}
            </button>
          </div>

          {/* End of Day section */}
          <div className="day-close-success-eod">
            <p className="day-close-success-eod-label">End of Day Actions</p>

            <button
              className="dcs-btn dcs-btn-dark"
              disabled={endDayLoading || loading}
              onClick={handleEndDayClick}
            >
              {endDayLoading || loading ? (
                <span className="dcs-btn-spinner" aria-hidden="true" />
              ) : (
                <>
                  Close Day Sales
                  <CalendarDaysIcon className="dcs-btn-icon-right" aria-hidden="true" />
                </>
              )}
            </button>

            <button
              className="dcs-btn dcs-btn-logout"
              onClick={handleLogoutFn}
              disabled={logoutLoading}
            >
              Logout
              {logoutLoading ? (
                <span className="dcs-btn-spinner-light" aria-hidden="true" />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="dcs-btn-icon-right"
                  aria-hidden="true"
                >
                  <path d="m16 17 5-5-5-5" />
                  <path d="M21 12H9" />
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </main>

      {/* End Day Options Modal — kept intact, untouched */}
      {/*
      <Modal
        open={endDayModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="end-day-modal-title"
        aria-describedby="end-day-modal-description"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <span role="img" aria-label="sun" style={{ fontSize: "20px" }}>
                🌤️
              </span>
              <span style={{ fontSize: "18px", fontWeight: 600, color: "#1a1a1a" }}>
                How Do You Want To End The Day?
              </span>
            </Box>
            <IconButton onClick={handleCloseModal} size="small" sx={{ color: "#666" }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <p style={{ fontSize: "14px", color: "#666", margin: "0 0 24px 0" }}>
            Pick one of the options below to wrap up your day!
          </p>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <PosCustomButton
              title="End day without report"
              width="50%"
              p={"12px 16px"}
              radius="4px"
              variant="red-transparent"
              loading={endDayLoading}
              onClickFunction={handleEndDayWithoutReport}
            />
            <PosCustomButton
              title="End day with Report"
              width="50%"
              p={"12px 16px"}
              radius="4px"
              variant="blue-d"
              loading={loading}
              onClickFunction={handleEndDayWithReport}
            />
          </Box>
        </Box>
      </Modal>
      */}

      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-popup"
      >
        <SliderTabManager
          setOpen={setOpen}
          totalAmountDen={totalAmountDen}
          comment={comment}
          commentI={commentI}
          denoArr={denoArr}
          navigate={navigate}
          closeTabName="day"
        />
      </Modal>
    </>
  );
};

export default DayClosing;
